<script lang="ts">
  import CommonHead from "../../organisms/settings/CommonHead.svelte";
</script>

<div class="flex">
  <div class="flex-1 mr-8">
    <CommonHead />
  </div>
</div>
